/**
 * Allow users to click on-click elements using the keyboard only
 */
const accessibility = () => {
	document.onkeydown = function( e ) {
		if ( e.keyCode === 13 ) {
			// The Enter/Return key
			document.activeElement.click();
		}
	};
};

export default accessibility;